<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Accounts Management</h4>
        </div>

    </div>
</div>


<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <diV class="row">
                                <div class="col-md-10">
                                    <label>All Accounts</label>
                                </div>
                                <div class="col-md-1">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="filter()">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>

                                </div>
                                <div class="col-md-1">

                                    <div id="zero_config_filter" class="dataTables_filter" (click)="exportTable()">
                                        <button style="background-color: #e0e09e">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                              
                            </diV>
                            
                            <div>
                                <div *ngIf="showFilter" style="background-color: #e0e09e;margin-top: 15px;width:895px">
                                    <div class="container-fluid" style="color: black">
                                       
                                        <input style="margin-top: 29px;" type="radio" id="mobile" name="gender"
                                         [(ngModel)]="filterValueSelected" value="pmn"  (change)="applyCustomizedFilter()"> Primary User Mobile Number &nbsp;&nbsp;
                                         <input style="margin-top: 29px;" type="radio" id="email" name="email"
                                         [(ngModel)]="filterValueSelected" value="ai"  (change)="applyCustomizedFilter()"> Email Address &nbsp;&nbsp;
                                         <input style="margin-top: 29px;" type="radio" id="company" name="company"
                                         [(ngModel)]="filterValueSelected" value="cn"  (change)="applyCustomizedFilter()"> Company Name &nbsp;&nbsp;

                                    </div>
                                    <div style="margin-left: 820px">
                                        <button class="btn btn-dark" (click)="filter()">Cancel</button>
    
                                    </div>
                                </div>
                                   <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput  [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                        <ng-container matColumnDef="emailAddress">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Address
                                            </th>
                                            <td *matCellDef="let row">{{row.emailAddress}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="primaryMobileNumber">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Primary User Mobile Number</th>
                                            <td *matCellDef="let row">{{row.primaryMobileNumber}}</td>
                                        </ng-container> 
                                        <ng-container matColumnDef="address">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                                            <td *matCellDef="let row">  {{row.address}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="companyName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Name</th>
                                            <td *matCellDef="let row"> {{row.companyName}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="companySize">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Size</th>
                                            <td *matCellDef="let row"> {{row.companySize}}</td>
                                        </ng-container>
                                       
                                    
                                        <ng-container matColumnDef="accountStatus">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Status</th>
                                            <td *matCellDef="let row">{{row.accountStatus}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>  Account Status</th>
                                            <td *matCellDef="let row">  <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span></td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfCreation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Of Creation</th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfCreation|date}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                                            <td *matCellDef="let row">
                                              
                                                <ul class="list-group list-group-flush"
                                                   >
                                                    <li class="list-group-item  friend-list mb-2">

                                                        <div class="dropdown show float-right list-block">

                                                            <a class="userDropdown" href="#" role="button"
                                                                id="userDropdown" data-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false"
                                                                style="padding-right: 170px;"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">
                                                               
                                                                <button class="dropdown-item"
                                                                    (click)="deleteAccount(row._id)"
                                                                    >
                                                                    <i class="fa fa-trash p-2"
                                                                        aria-hidden="true"></i>Delete</button>
                                                               
                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>
                                        <!-- <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                                        <td *matCellDef="let row">
                                          <mat-slide-toggle (change)="onChange($event,row.id)" class="example-margin" [color]="color" [checked]="row.status">
                                          </mat-slide-toggle>
                                        </td>
                                      </ng-container> -->
                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->